import React, { useState } from 'react'
import schema from '../../../../routes/permissions/schema'

import RecordActionButton from './RecordActionButton'

const RecordActions = (props) => {
  const { event, encoders, handleRecord, handleStop, handlePause } = props
  const [lastRequest, setLastRequest] = useState(0)
  const status = event.eventStatus.toLowerCase()
  const eventEncoder =
    event.assignedEncoder &&
    encoders.data.find(
      (encoder) => encoder.encoderID === event.assignedEncoder
    )
  const encoderOnline = eventEncoder && eventEncoder.online
  const recOk = (status === 'available' || status === 'new') && encoderOnline
  const handleAction = (next) => {
    setLastRequest(new Date().getTime())
    return next
  }
  // request was within 2.5 seconds
  const requestDelayTime = 2500
  const recentRequest = lastRequest > new Date().getTime() - requestDelayTime

  const recordButton = <RecordActionButton
    key={"Star action buttont"}
    permissionCheck={schema.EVENT.RECORD_START}
    title="Start"
    className="btn record"
    disabled={recentRequest || !recOk}
    onClick={(e) => {
      handleAction(handleRecord)(e)
    }}
    imageElement={<i className='fa fa-circle' />}
  />
  const stopButton = <RecordActionButton
    key={"Stop action button"}
    permissionCheck={schema.EVENT.RECORD_STOP}
    title="Stop"
    className="btn stop"
    disabled={recentRequest || status !== 'live'}
    onClick={(e) => {
      handleAction(handleStop)(e)
    }}
    imageElement={<i className='fa fa-stop' />}
  />

  const pauseButton = <RecordActionButton
    key={"Paus action buttone"}
    permissionCheck={schema.EVENT.RECORD_PAUSE}
    title="Pause"
    className="btn pause"
    disabled={recentRequest || status !== 'live'}
    onClick={(e) => {
      handleAction(handlePause)(e)
    }}
    imageElement={<i className='fa fa-pause' />}
  />

  const playButton = <RecordActionButton
    key={"play action button"}
    permissionCheck={schema.EVENT.RECORD_PAUSE}
    title="Resume"
    className="btn play"
    disabled={recentRequest}
    onClick={(e) => {
      handleAction(handlePause)(e)
    }}
    imageElement={<i className='fa fa-play' />}
  />

  return [recordButton, stopButton, status === 'on break' ? playButton : pauseButton]
}

export default RecordActions
